(function () {
  'use strict';

  var GEO_GATE_ENABLED = true;
  var BLOCKED_COUNTRY = 'CN';
  var GEO_TIMEOUT_MS = 1500;
  var CACHE_KEY = 'shopify_geo_country_v2';
  var CACHE_TTL_MS = 30 * 60 * 1000;
  var ACCESS_PARAM = 'voicecan_access';
  var ACCESS_TOKEN = '3f505a8456f6ce1f84762630c4e868627facfff7ed8a9327';
  var ACCESS_CACHE_KEY = 'shopify_geo_bypass_v1';
  var ACCESS_CACHE_TTL_MS = 12 * 60 * 60 * 1000;
  var script = document.currentScript || document.querySelector('script[data-logo-src]');

  function isThemeEditor() {
    return window.Shopify && window.Shopify.designMode === true;
  }

  function hasAccessToken() {
    try {
      return new URL(window.location.href).searchParams.get(ACCESS_PARAM) === ACCESS_TOKEN;
    } catch (error) {
      return false;
    }
  }

  function readCachedBypass() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(ACCESS_CACHE_KEY) || 'null');
      var timestamp = cached && Number(cached.timestamp);
      if (cached && timestamp > 0 && Date.now() - timestamp <= ACCESS_CACHE_TTL_MS) return true;
      sessionStorage.removeItem(ACCESS_CACHE_KEY);
    } catch (error) {
      return false;
    }
    return false;
  }

  function activateBypass() {
    try {
      sessionStorage.setItem(ACCESS_CACHE_KEY, JSON.stringify({ timestamp: Date.now() }));
      var url = new URL(window.location.href);
      url.searchParams.delete(ACCESS_PARAM);
      window.history.replaceState({}, document.title, url.toString());
    } catch (error) {
      // The current page still works if storage or history is unavailable.
    }
  }

  function readCachedCountry() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      var country = cached && typeof cached.country === 'string' ? cached.country.toUpperCase() : '';
      var timestamp = cached && Number(cached.timestamp);
      if (!country || !Number.isFinite(timestamp) || timestamp <= 0 || Date.now() - timestamp > CACHE_TTL_MS) {
        sessionStorage.removeItem(CACHE_KEY);
        return null;
      }
      return country;
    } catch (error) {
      return null;
    }
  }

  function writeCachedCountry(country) {
    if (!country) return;
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ country: country, timestamp: Date.now() }));
    } catch (error) {
      // Storage can be unavailable in private browsing; the current page still works.
    }
  }

  function detectCountry() {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, GEO_TIMEOUT_MS) : null;
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (controller) options.signal = controller.signal;

    return fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', options)
      .then(function (response) {
        if (!response.ok) throw new Error('Geo request failed');
        return response.json();
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        return typeof country === 'string' && country ? country.toUpperCase() : null;
      })
      .finally(function () {
        if (timer) window.clearTimeout(timer);
      });
  }

  function removeVeil() {
    var veil = document.getElementById('geo-gate-veil');
    if (veil && veil.parentNode) veil.parentNode.removeChild(veil);
  }

  function allow() {
    document.documentElement.classList.add('geo-gate-ready');
    window.setTimeout(removeVeil, 200);
  }

  function showRestrictedPage() {
    if (document.getElementById('geo-blocked-screen')) return;

    var shopName = script ? script.getAttribute('data-shop-name') || 'Voicecan' : 'Voicecan';
    var logoSrc = script ? script.getAttribute('data-logo-src') || '' : '';
    var screen = document.createElement('div');
    screen.id = 'geo-blocked-screen';
    screen.className = 'geo-blocked-screen';
    screen.setAttribute('role', 'status');
    screen.setAttribute('aria-live', 'polite');

    var inner = document.createElement('div');
    inner.className = 'geo-blocked-screen__inner';

    if (logoSrc) {
      var logo = document.createElement('img');
      logo.className = 'geo-blocked-screen__logo';
      logo.src = logoSrc;
      logo.alt = shopName;
      logo.width = 148;
      logo.height = 28;
      inner.appendChild(logo);
    }

    var title = document.createElement('h1');
    title.className = 'geo-blocked-screen__title';
    title.textContent = "Sorry, this page isn’t available right now.";
    inner.appendChild(title);
    screen.appendChild(inner);

    document.body.replaceChildren(screen);
    document.title = shopName;
    document.documentElement.classList.add('geo-gate-restricted');
  }

  function decide(country) {
    if (country === BLOCKED_COUNTRY) showRestrictedPage();
    else allow();
  }

  if (!GEO_GATE_ENABLED || isThemeEditor()) {
    allow();
    return;
  }
  if (hasAccessToken()) {
    activateBypass();
    allow();
    return;
  }
  if (readCachedBypass()) {
    allow();
    return;
  }

  var cachedCountry = readCachedCountry();
  if (cachedCountry) {
    decide(cachedCountry);
    return;
  }

  var settled = false;
  function finish(country) {
    if (settled) return;
    settled = true;
    if (country) writeCachedCountry(country);
    decide(country);
  }

  window.setTimeout(function () { finish(null); }, GEO_TIMEOUT_MS);
  detectCountry().then(finish).catch(function () { finish(null); });
}());
